
import React, { useState, useEffect } from "react";

import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import IconButton from "@material-ui/core/IconButton";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Collapse from '@material-ui/core/Collapse';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { withStyles } from "@material-ui/core/styles";
import LanguageIcon from "@material-ui/icons/Language";
import CloseIcon from "@material-ui/icons/Close";
import GroupIcon from "@material-ui/icons/Group";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpandLess from "@material-ui/icons/ExpandLess";
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import StarIcon from '@material-ui/icons/Star';
import HelpIcon from '@material-ui/icons/Help';
import LoyaltyIcon from '@material-ui/icons/Loyalty';
import SchoolIcon from '@material-ui/icons/School';
import BuildIcon from '@material-ui/icons/Build';
import StopIcon from '@material-ui/icons/Stop';

import { DialogActions, Hidden } from "@material-ui/core";





const styles = theme => ({
	subtitle: {
		fontWeight: "bold",
		textTransform: "uppercase",
	},
	companyName: {
		lineHeight: "1.2em"
	},
	websiteButton: {
		marginTop: 8,
		paddingTop: 2,
		paddingBottom: 1,
	},
	parentJobposition: {
		paddingLeft: 0,
	}
});

const CompanyDetailsDialog = ({ company, formphase, language, favorites, setFavorites, getWorkingTimeOffers, closeDialog, signupstatus, classes, fullScreen }) => {
	const [isPositionExpanded, setIsPositionExpanded] = useState({});
	const [selectedJobpositions, setSelectedJobpositions] = useState([]);
	const [isCurrentFavorite, setIsCurrentFavorite] = useState(false);
	const [isWHATExpanded, setIsWHATExpanded] = useState(false);
	const [isWHYExpanded, setIsWHYExpanded] = useState(false);

	useEffect(() => {
		if (company !== null) {

			// initialize to false
			const newIsPositionExpanded = {};
			company.jobpositions.filter(pos => pos.has_children).forEach((pos) => {
				newIsPositionExpanded[pos.ID] = true;
			});
			setIsPositionExpanded(newIsPositionExpanded);
			const currentFavorites = favorites.filter(fav => fav.id === company.ID);
			const currentFavorite = currentFavorites.length > 0 ? currentFavorites[0] : null;
			if (currentFavorite) {
				setSelectedJobpositions(currentFavorite.positions);
				setIsCurrentFavorite(true);
			} else {
				setSelectedJobpositions([]);
				setIsCurrentFavorite(false);
			}
			setIsWHATExpanded(false);
			setIsWHYExpanded(false);
		}
	}, [company]);

	if (company === null)
		return <></>;

	const workingTimeOffers = getWorkingTimeOffers(company);

	const languageRequirements = [];
	let languageRequirementsHeadline = "";
	let languageRequirementsDescription = "";
	const languageDisplayNames = {
		"de": {
			"A1": "A1 – erste Grundkenntnisse",
			"A2": "A2 – vertiefte Grundkenntnisse",
			"B1": "B1 – gute Sprachkenntnisse",
			"B2": "B2 – fließend",
			"C1": "C1 – fließend bis verhandlungssicher",
			"C2": "C2 – Muttersprachenniveau",
		},
		"en": {
			"A1": "A1 – Basic language skills",
			"A2": "A2 – Elementary language skills",
			"B1": "B1 – Good language skills",
			"B2": "B2 – Fluent language proficiency",
			"C1": "C1 – Fluent to advanced language skills",
			"C2": "C2 – Native language proficiency",
		}
	};
	if (company.german && company.german.length > 0 && company.german !== "Egal") {
		if (languageDisplayNames[language][company.german]) {
			languageRequirements.push((language === "en" ? "German " : "Deutsch ") + languageDisplayNames[language][company.german]);
		}
	}
	if (company.english && company.english.length > 0 && company.english !== "Egal") {
		if (languageDisplayNames[language][company.english]) {
			languageRequirements.push((language === "en" ? "English " : "Englisch ") + languageDisplayNames[language][company.english]);
		}
	}
	if (languageRequirements.length === 2) {
		if (company.language_join === "UND") {
			if (language === "en") {
				languageRequirementsHeadline = "Languages (both required)";
				languageRequirementsDescription = <>{languageRequirements[0]}<br />{languageRequirements[1]}</>;
			} else {
				languageRequirementsHeadline = "Sprachen (beide erforderlich)";
				languageRequirementsDescription = <>{languageRequirements[0]}<br />{languageRequirements[1]}</>;
			}
		} else {
			if (language === "en") {
				languageRequirementsHeadline = "Languages (one of them required)";
				languageRequirementsDescription = <>{languageRequirements[0]}<br />{languageRequirements[1]}</>;
			} else {
				languageRequirementsHeadline = "Sprachen (eine davon erforderlich)";
				languageRequirementsDescription = <>{languageRequirements[0]}<br />{languageRequirements[1]}</>;
			}
		}
	} else if (languageRequirements.length === 1) {
		if (language === "en") {
			languageRequirementsHeadline = "Language";
			languageRequirementsDescription = languageRequirements[0];
		} else {
			languageRequirementsHeadline = "Sprache";
			languageRequirementsDescription = languageRequirements[0];
		}
	}

	const getButtonCaption = () => {
		if (isCurrentFavorite) {
			return language === "en" ? "Update favorites" : "Favoriten aktualisieren";
		}
		return language === "en" ? "Add to favorites" : "Zu Favoriten hinzufügen";
	};

	// prepare website url
	let website = company.website;
	if (!website || website.length < 3) {
		website = "";
	} else if (!website.startsWith("http")) {
		website = "https://" + website;
	}
	// if contains comma, split and use first one
	if (website.includes(",")) {
		website = website.split(",")[0];
	}

	return (
		<>
			<Dialog
				open={company !== null}
				onClose={() => closeDialog()}
				maxWidth="md"
				fullWidth
				fullScreen={fullScreen}
			>
				<DialogTitle>
					<Grid container spacing={16}>
						<Grid item xs={3}>
							{company.logo_url &&
								<img src={company.logo_url} alt={company.name} style={{ width: 130, maxWidth: "100%" }} />
							}
						</Grid>
						<Grid item xs={7} className={classes.companyName}>
							{company.name}
							<br />
							{website !== "" &&
								<Button
									size="small"
									href={website}
									variant="outlined"
									target="_blank"
									className={classes.websiteButton}
								>
									{language === "en" ? "Show website" : "Website anzeigen"}
								</Button>
							}
						</Grid>
						<Grid item xs={2} align="right">
							<IconButton color="inherit" onClick={() => closeDialog()} aria-label="Schließen">
								<CloseIcon />
							</IconButton>
						</Grid>
					</Grid>
				</DialogTitle>
				<DialogContent>
					<Grid container spacing={16}>
						<Grid item xs={2} md={1}>
							<PlaylistAddCheckIcon />
						</Grid>
						<Grid item xs={10} md={11}>
							<Typography variant="subtitle2" className={classes.subtitle} inline>{language === "en" ? "Industry" : "Branche"}: </Typography>
							<Typography variant="body1" inline>
								{company.industry}
							</Typography>
							<br />
							<Typography variant="subtitle2" className={classes.subtitle} inline>{language === "en" ? "Specialization" : "Spezialisierung"}: </Typography>
							<Typography variant="body1" inline>
								{company.specialization}
							</Typography>
							<br />
							<Typography variant="subtitle2" className={classes.subtitle} inline>{language === "en" ? "Number of employees" : "Anzahl der Beschäftigten"}: </Typography>
							<Typography variant="body1" inline>
								{company.size} {language === "en" ? " employees" : " Beschäftigte"}
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<Divider />
						</Grid>
						<Grid item xs={2} md={1}>
							<LocationOnIcon />
						</Grid>
						<Grid item xs={10} md={11}>
							{/* <Typography variant="subtitle2" className={classes.subtitle}>{language === "en" ? "Main location/head office" : "Hauptstandort / Zentrale"}</Typography>
							<Typography variant="body1">
								{company.locations}
							</Typography>
							<br /> */}
							<Typography variant="subtitle2" className={classes.subtitle} >{language === "en" ? "Locations for which you can apply at the LNDB" : "Standorte, für die man sich bei der LNDB bewerben kann"} </Typography>
							<Typography variant="body1" >
								{company.current_location}
							</Typography>
						</Grid>
						{company.why && company.why.length > 3 &&
							<Grid item xs={12}>
								<Divider />
							</Grid>
						}
						{company.why && company.why.length > 3 &&
							<Grid item xs={2} md={1}>
								<HelpIcon />
							</Grid>
						}
						{company.why && company.why.length > 3 &&
							<Grid item xs={10} md={11}>
								<Typography variant="subtitle2" className={classes.subtitle}>
									{language === "en" ? "Why our company is particularly attractive to you" : "Warum gerade unser Unternehmen attraktiv für dich ist"}
									<IconButton
										onClick={() => setIsWHYExpanded(!isWHYExpanded)}
										style={{ padding: 0 }}
									>
										{isWHYExpanded ? <ExpandLess /> : <ExpandMore />}
									</IconButton>
								</Typography>
								<Collapse
									in={isWHYExpanded}
									timeout="auto"
									unmountOnExit
								>
									<Typography variant="body1">
										{company.why}
									</Typography>
								</Collapse>
							</Grid>
						}
						{company.benefits && company.benefits.length > 3 &&
							<Grid item xs={12}>
								<Divider />
							</Grid>
						}
						{company.benefits && company.benefits.length > 3 &&
							<Grid item xs={2} md={1}>
								<LoyaltyIcon />
							</Grid>
						}
						{company.benefits && company.benefits.length > 3 &&
							<Grid item xs={10} md={11}>
								<Typography variant="subtitle2" className={classes.subtitle}>
									{language === "en" ? "What to expect from us" : "Was dich bei uns erwartet"}
									<IconButton
										onClick={() => setIsWHATExpanded(!isWHATExpanded)}
										style={{ padding: 0 }}
									>
										{isWHATExpanded ? <ExpandLess /> : <ExpandMore />}
									</IconButton>
								</Typography>
								<Collapse
									in={isWHATExpanded}
									timeout="auto"
									unmountOnExit
								>
									<Typography variant="body1">
										{company.benefits}
									</Typography>
								</Collapse>
							</Grid>
						}
						{languageRequirementsDescription !== "" &&
							<Grid item xs={12}>
								<Divider />
							</Grid>
						}
						{languageRequirementsDescription !== "" &&
							<Grid item xs={2} md={1}>
								<LanguageIcon />
							</Grid>
						}
						{languageRequirementsDescription !== "" &&
							<Grid item xs={10} md={11}>
								<Typography variant="subtitle2" className={classes.subtitle}>{languageRequirementsHeadline}</Typography>
								<Typography variant="body1">
									{languageRequirementsDescription}
								</Typography>
							</Grid>
						}
						{workingTimeOffers.length > 0 &&
							<Grid item xs={12}>
								<Divider />
							</Grid>
						}
						{workingTimeOffers.length > 0 &&
							<Grid item xs={2} md={1}>
								<ThumbUpIcon />
							</Grid>
						}
						{workingTimeOffers.length > 0 &&
							<Grid item xs={10} md={11}>
								<Typography variant="subtitle2" className={classes.subtitle} inline>{language === "en" ? "We offer... " : "Wir bieten... "}</Typography>
								<Typography variant="body1" inline>
									{workingTimeOffers.join(", ")}
								</Typography>
							</Grid>
						}
						<Grid item xs={12}>
							<Divider />
						</Grid>
						<Hidden only="xs">
							<Grid item xs={2} md={1}>
								<GroupIcon />
							</Grid>
						</Hidden>
						<Grid item xs={12} md={11}>
							<Typography variant="subtitle2" className={classes.subtitle} color="primary">
								{language === "en" ? "You can apply for the following jobs" : "Für folgende Jobpositionen kannst du dich bei der LNDB bewerben"}
							</Typography>
							<List
								component="nav"
							>
								{company.jobpositions.filter(pos => pos.has_children).map((pos) => {
									const subpositions = company.jobpositions.filter(subpos => subpos.parent === pos.ID);
									const selectedSubpositions = subpositions.filter(subpos => selectedJobpositions.includes(subpos.ID));
									let subpositionsStatusText = "";
									if (formphase === "registration") {
										if (language === "en") {
											subpositionsStatusText = `${selectedSubpositions.length} of ${subpositions.length} positions selected`;
										} else {
											subpositionsStatusText = `${selectedSubpositions.length} von ${subpositions.length} Positionen ausgewählt`;
										}
									}
									return (
										<div key={pos.ID}>
											<ListItem
												value={pos.ID}
												className={classes.parentJobposition}
												onClick={() => setIsPositionExpanded({ ...isPositionExpanded, [pos.ID]: !isPositionExpanded[pos.ID] })}
											>
												<ListItemText primary={pos.name} secondary={subpositionsStatusText} />
												{isPositionExpanded[pos.ID] ? <ExpandLess /> : <ExpandMore />}
											</ListItem>

											{subpositions.map((subpos) => (
												<Collapse
													in={isPositionExpanded[pos.ID]}
													key={subpos.ID}
													timeout="auto"
													unmountOnExit
												>
													<List
														component="div"
														disablePadding
														dense
													>
														<ListItem
															button={formphase === "registration"}
															className={classes.nested}
															onClick={() => {
																if (selectedJobpositions.includes(subpos.ID)) {
																	setSelectedJobpositions(selectedJobpositions.filter(id => id !== subpos.ID));
																} else {
																	setSelectedJobpositions([...selectedJobpositions, subpos.ID]);
																}
															}}
														>
															{formphase === "registration" ?
																<ListItemIcon>
																	{selectedJobpositions.includes(subpos.ID) ?
																		<CheckBoxIcon />
																		: <CheckBoxOutlineBlankIcon />
																	}
																</ListItemIcon>
																: <ListItemIcon><StopIcon /></ListItemIcon>
															}
															<ListItemText primary={subpos.name} />
														</ListItem>
													</List>
												</Collapse>
											))}

										</div>
									);
								})}
							</List>
						</Grid>
						{company.qualification && company.qualification.length > 3 &&
							<Grid item xs={12}>
								<Divider />
							</Grid>
						}
						{company.qualification && company.qualification.length > 3 &&
							<Hidden only="xs">
								<Grid item xs={2} md={1}>
									<SchoolIcon />
								</Grid>
							</Hidden>
						}
						{company.qualification && company.qualification.length > 3 &&
							<Grid item xs={12} md={11}>
								<Typography variant="subtitle2" className={classes.subtitle}>{language === "en" ? "Suitable education" : "Passende Ausbildungen"}</Typography>
								<Typography variant="body1">
									{company.qualification}
								</Typography>
							</Grid>
						}
						{company.techstack && company.techstack.length > 3 &&
							<Grid item xs={12}>
								<Divider />
							</Grid>
						}
						{company.techstack && company.techstack.length > 3 &&
							<Hidden only="xs">
								<Grid item xs={2} md={1}>
									<BuildIcon />
								</Grid>
							</Hidden>
						}
						{company.techstack && company.techstack.length > 3 &&
							<Grid item xs={12} md={11}>
								<br />
								<Typography variant="h6">{language === "en" ? "We use the following technologies:" : "Folgende Technologien sind bei uns im Einsatz:"}</Typography>
								<Typography variant="body1">
									{company.techstack}
								</Typography>
							</Grid>
						}
					</Grid>
				</DialogContent>
				{formphase === "registration" ?
					<DialogActions>
						{(!isCurrentFavorite && favorites.length >= 7) &&
							<Typography variant="body2" style={{ padding: 10 }} color="error">
								{language === "en" ? "You can only save up to 7 favorites" : "Du kannst maximal 7 Favoriten speichern"}
							</Typography>
						}
						<Button
							size="small"
							onClick={() => {
								closeDialog();
							}}
						>
							{language === "en" ? "back" : "zurück"}
						</Button>
						{isCurrentFavorite &&
							<Button
								variant="contained"
								size="small"
								onClick={() => {
									// remove company from favorites if already there
									const newFavorites = favorites.filter(fav => fav.id !== company.ID);

									setFavorites(newFavorites);
									closeDialog();
								}}
							>
								{language === "en" ? "Remove from favorites" : "Aus Favoriten entfernen"}
							</Button>
						}
						<Button
							variant="contained"
							disabled={selectedJobpositions.length === 0 || (!isCurrentFavorite && favorites.length >= 7)}
							size="small"
							onClick={() => {
								// is already in favorites?
								if (isCurrentFavorite) {
									// modify existing
									setFavorites(favorites.map(fav => {
										if (fav.id === company.ID) {
											return {
												id: company.ID,
												positions: selectedJobpositions
											};
										}
										return fav;
									}));
								} else {
									setFavorites([...favorites, {
										id: company.ID,
										positions: selectedJobpositions
									}]);
								}
								closeDialog();
							}}
							color="primary"
						>
							{getButtonCaption()}

							<StarIcon style={{
								marginLeft: 10,
							}} />
						</Button>
					</DialogActions>
					:
					<DialogActions>
						<Typography variant="caption" style={{ padding: 10 }}>
							{signupstatus.error_msg}
						</Typography>
					</DialogActions>
				}
			</Dialog>
		</>
	);

}

export default withStyles(styles)(withMobileDialog()(CompanyDetailsDialog));
